import api from 'services/api';

export const CLIENTS_COUNT = 'clients/count';
export const CLIENTS_FETCH_LINK_CANDIDATES = 'clients/fetchLinkCandidates';
export const CLIENTS_LINK = 'clients/link';
export const CLIENTS_DISCONNECT = 'clients/disconnect';
export const CLIENTS_TRANSFER_OWNERSHIP = 'clients/transferOwnership';
export const CLIENTS_CANCEL_TRANSFER_OWNERSHIP =
  'clients/cancelTransferOwnership';
export const CLIENTS_FETCH_DEACTIVATED = 'clients/fetchDeactivated';
export const CLIENTS_DEACTIVATE = 'clients/deactivate';
export const CLIENTS_REACTIVATE = 'clients/reactivate';

const actions = {
  count(params) {
    return {
      type: CLIENTS_COUNT,
      payload: api.get('/partner/clients/count', params),
    };
  },

  fetchLinkCandidates() {
    return {
      type: CLIENTS_FETCH_LINK_CANDIDATES,
      payload: api.get('/partner/clients/link-candidates'),
    };
  },

  link(clientIds) {
    return {
      type: CLIENTS_LINK,
      payload: api.post('/partner/clients/link', { client_ids: clientIds }),
    };
  },

  disconnect(id) {
    return {
      type: CLIENTS_DISCONNECT,
      payload: api.post(`/partner/clients/${id}/disconnect`),
    };
  },

  transferOwnership(id, email) {
    return {
      type: CLIENTS_TRANSFER_OWNERSHIP,
      payload: api.post(`/partner/clients/${id}/transfer-ownership`, {
        email,
      }),
    };
  },

  cancelTransferOwnership(id) {
    return {
      type: CLIENTS_CANCEL_TRANSFER_OWNERSHIP,
      payload: api.post(`/partner/clients/${id}/cancel-transfer`),
    };
  },

  fetchDeactivated(params) {
    return {
      type: CLIENTS_FETCH_DEACTIVATED,
      payload: api.get('/partner/clients/deactivated', params),
    };
  },

  deactivate(id) {
    return {
      type: CLIENTS_DEACTIVATE,
      payload: api.post(`/partner/clients/${id}/deactivate`),
    };
  },

  reactivate(id) {
    return {
      type: CLIENTS_REACTIVATE,
      payload: api.post(`/partner/clients/${id}/reactivate`),
    };
  },
};

export default actions;
